import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { LOGO_KASTOR, LOGO_KIUNGO } from '../../app.service';

// Services
import { SidebarService } from '../../services/sidebar.service';
import { AdministrationService } from '../../services/administration.service';
import { AppBase } from '../../app-base';
import { UserService } from '../../services/user.service';
import { PermissionGroupService } from '../../services/permissionGroup.service';

// Menu
declare var require: any;
const jsonMenu = require('../../../assets/menu/menu.json');

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.sass']
})

export class ToolbarComponent extends AppBase implements OnInit {

  // variables
  public administrationName: string;
  public userInSession: string;
  public showCurrentUserForm: boolean;
  public currentSessionUserId: number;
  public menu = null;
  public search = null;
  public query = '';
  public imageUser = null;
  public imgUser = null;
  public isCommunity: any = false;
  public logoCommunity = LOGO_KASTOR;
  public realmUser = null;
  public menuXs = false;
  public debtStatus = null;
  public hideDebtStatus = false;
  public notificationRealm = '';
  public permissionUser = '';

  @Input()
  public showSearch = false;
  @Input()
  public showPublications = false;
  constructor(private _translateService: TranslateService,
              private _userService: UserService,
              private _administrationService: AdministrationService,
              private _sidebarService: SidebarService,
              private _router: Router,
              private _permissionGroupService?: PermissionGroupService) {
    super();

    if (this.currentUser) {
      this.realmUser = this.currentUser.realm;
    }
  }

  ngOnInit() {
    this._administrationService.getAdministrationById(this.currentUser.administration_id)
      .subscribe(administration => {
        this.administrationName = administration.name;
      });

    this._administrationService.getAdministrationSetting(this.currentUser.administration_id)
      .subscribe(settings => {
        const debtStatusSetting = settings.administrationSettings.find(s => s.administrationSettingsField.key === 'ADMINISTRATION_DEBT_STATUS');
        if (debtStatusSetting) {
          this.debtStatus = debtStatusSetting.value.status;
        }
      });

    this._userService.getUserById(this.currentUser.user_id).subscribe(user => {
      this.imageUser = user.user_img;
    });

    this.isCommunity = !!this.currentUser.community_id;


    if (this.realmUser === 'kiungo') {
      this.logoCommunity = LOGO_KIUNGO;
      this.notificationRealm = 'Kiungo';
    } else {
      this.notificationRealm = 'Kastor';
    }

    const group = this._permissionGroupService.userPermission();

    group.subscribe(permissions => {
      this.permissionUser = permissions;
      this.menu = jsonMenu.menu;

      if (this.menu) {
        const listsOfMenuItems = [];
        this.menu.forEach(element => {
          if (element.link && this.permissionUser.includes(element.permission)) {
            listsOfMenuItems.push(element);
          } else {
            if (element.sub.length > 0) {
              element.sub.forEach(item => {
                if (item.sub.length > 0) {
                  item.sub.forEach(ele => {
                    if (ele.sub.length > 0) {
                      ele.sub.forEach(elem => {
                        if (elem.link && this.permissionUser.includes(elem.permission)) {
                          listsOfMenuItems.push(elem);
                        }
                      });
                    } else {
                      if (ele.link && this.permissionUser.includes(ele.permission)) {
                        listsOfMenuItems.push(ele);
                      }
                    }
                  });
                } else {
                  if (item.link && this.permissionUser.includes(item.permission)) {
                    listsOfMenuItems.push(item);
                  }
                }
              });
            }
          }
        });

        this.search = listsOfMenuItems;

        const translationList = [];

        this.search.forEach(menu => {
          translationList.push(menu.name);
          if (menu.tags) {
            menu.tags.forEach(tag => {
              translationList.push(tag);
            });
          }
        });

        this._translateService.get(translationList)
          .subscribe((translation: any) => {
            this.search.forEach(itemMenu => {
              itemMenu.textTags = [];
              const text = translation[itemMenu.name];
              itemMenu.text = text;
              if (itemMenu.tags) {
                itemMenu.tags.forEach(tag => {
                  const textTag = translation[tag];
                  itemMenu.textTags.push(textTag);
                });
              }
            });
          });
      }
    });

    if (this.currentUser) {
      this._userService.getUserById(this.currentUser.user_id).subscribe(user => {
        this.userInSession = `${user.name} ${user.lastname.length > 0 ? user.lastname.charAt(0) : ''}.`;
        this.currentSessionUserId = this.currentUser.user_id;
        this.showCurrentUserForm = true;

        if (user.user_img) {
          this.imgUser = user.user_img;
        } else {
          this.imgUser = '../../../assets/img/user-not-found.png';
        }
      });

    }
  }

  public toggleClass(): void {
    this._sidebarService.changeStateSidebar();
  }

  public clear(): void {
    this.cleanStorage();
  }

  public clickLink(): void {
    this.query = '';
  }

  public queryTrim(): string {
    return this.query.trim();
  }

  public returnSelectCommunity(): void {
    this._router.navigate(['/communities']);
  }

  public closeDebtStatus(): void {
    this.hideDebtStatus = true;
  }

}



// WEBPACK FOOTER //
// ./src/app/layout/toolbar/toolbar.component.ts